import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SettingsState {
  requireEmailVerification: boolean;
  stripePublishableKey: string;
  paymentGateway: string;
  freeSubscriptionEnabled: boolean;
  freeSubscriptionDuration: number;
  minimumSubscriptionPrice: number;
  maximumSubscriptionPrice: number;
  minimumWalletPrice: number;
  maximumWalletPrice: number;
  minimumTipPrice: number;
  maximumTipPrice: number;
  minimumPayoutAmount: number;
  volume: number;
  gaCode?: string;
  [key: string]: any;
}

const initialState: SettingsState = {
  requireEmailVerification: false,
  stripePublishableKey: '',
  paymentGateway: 'stripe',
  freeSubscriptionEnabled: true,
  freeSubscriptionDuration: 1,
  minimumSubscriptionPrice: 2.95,
  maximumSubscriptionPrice: 300,
  minimumWalletPrice: 2.95,
  maximumWalletPrice: 300,
  minimumTipPrice: 10,
  maximumTipPrice: 10000,
  minimumPayoutAmount: 50,
  volume: 1
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    updateSettings(state, action: PayloadAction<Partial<SettingsState>>) {
      Object.assign(state, action.payload);
    },
    resetSettings() {
      return initialState;
    }
  }
});

export const { updateSettings, resetSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
